// extracted by mini-css-extract-plugin
export default {"banner":"CookieConsent_banner__dV+Ps"};